import React, { Suspense } from "react";
import Redeem from './views/Redeem'
import Wuliu from './views/Wuliu'
import NotFound from "./views/Notfound";


import { Redirect, Switch, Route } from "react-router-dom";
import { createBrowserHistory } from 'history';
// import {APImenu} from './api/home';

import './assets/css/common.css'
export const history = createBrowserHistory()
function App() {
  const init_url = window.location.href;
  if (init_url) {
    sessionStorage.setItem('init_url', init_url);
  }
  //获取菜单
  let menu = []
  //  APImenu().then((res) => {
  //   console.log(res)
  //   if(res.data.code===0){
  //     menu = res.data.data
  //   } 
  // })
  return (
    <div className="App">
      <Route history={history}></Route>
      <Suspense>
        <Switch>
          {
            menu.map((item) => (
              <Route path={item.url} component={item.component} key={item.id} />
            ))
          }
          <Route exact path="/redeem" component={Redeem} />
          <Route exact path="/wuliu" component={Wuliu} />
          <Redirect exact from="/" to="/redeem" />
          <Route path="*" component={NotFound} />
        </Switch>
      </Suspense>

    </div>
  );
}

export default App;
